import { CardMedia, Typography } from "@material-ui/core";
import { ReactElement } from "react";

import icon from "../../../../assets/icons/form.svg";
import { Heading } from "../../../../components/Heading";
import { FormType } from "../../../../components/enums";
import { Url } from "../../../../router/enums";
import { GenericPreload } from "../../../GenericPreload";

import styles from "./Preload.module.scss";

export const Preload = (): ReactElement => (
  <GenericPreload
    form={FormType.OC_VEHICLE}
    /* JIRA LPPLWEBMOB-721 */
    //redirection={Url.OC_VEHICLE_INTRODUCTORY}
    redirection={Url.OC_VEHICLE_SENDING}
  >
    <CardMedia component="img" src={icon} className={styles.icon} />
    <Heading
      align="center"
      color="secondary"
      component="h1"
      variant="h2"
      spacingBottom={{ xs: 4, sm: 6 }}
    >
      Weryfikacja reCAPTCHA
    </Heading>
    <Typography paragraph align="center">
      Wypełnij reCAPTCHA aby potwierdzić, że nie jesteś robotem i przesłać
      formularz.
    </Typography>
  </GenericPreload>
);
